/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import * as actionTypes from './actionTypes';
import * as serviceEndPoint from '../../../../SharedModules/services/service';

export const dispatchAllRebateProgramCode = (data) => {
  return {
    type: actionTypes.GET_ALL_REBATE_PROGRAMS,
    payload: data,
  };
};

export const setReqURACalcData = (data) => {
  return {
    type: actionTypes.SET_REQ_URA_DATA,
    payload: data,
  };
};
export const setErrorMessagesData = (messages) => {
  return {
    type: actionTypes.SET_ERROR_MESSAGES_REQ_URA_CAL,
    payload: messages,
  };
};
export const resetReqURLCalcStore = () => {
  return {
    type: actionTypes.RESET_REQUEST_URA_CALCULATION_STORE,
  };
};

export const getRebateProgramCode = (values) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_ALL_REBATE_PROGRAMS_URA}`, values)
    .then((response) => {
      return dispatch(dispatchAllRebateProgramCode(response.data));
    })
    .catch((response) => {
      dispatch(dispatchAllRebateProgramCode(response.date));
    });
};
export const getRebateProgramCodeOLD = (values) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_ALL_REBATE_PROGRAMS}`, { planType: values })
    .then((response) => {
      return dispatch(dispatchAllRebateProgramCode(response.data));
    })
    .catch((response) => {
      dispatch(dispatchAllRebateProgramCode(response.date));
    });
};

export const dispatchManufacturersByPQR = (data) => {
  return {
    type: actionTypes.GET_MANUFACTURERS_BY_REQ_URA_CAL,
    payload: data,
  };
};

export const getManufacturersByPQR = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_MANUFACTURERS_BY_URA, values)
    .then((response) => {
      return dispatch(dispatchManufacturersByPQR(response.data));
    })
    .catch(() => {
      dispatch(dispatchManufacturersByPQR([]));
    });
};

export const dispatchCalculateInvoice = (data) => {
  return {
    type: actionTypes.CALCULATE_INVOICE,
    payload: data,
  };
};

export const calculateURA = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.REQUEST_URA_CALC, values)
    .then((response) => {
      return dispatch(dispatchCalculateInvoice(response.data));
    })
    .catch(() => {
      dispatch(dispatchCalculateInvoice({ error: 'API failed' }));
    });
};

export const setDefaultQtr = (data) => {
  return {
    type: actionTypes.SET_DEFAULT_QTR,
    defaultQtrURA: data,
  };
};

export const getMaxQuarterForFreezeDt = () => (dispatch) => {
  return axios
    .get(`${serviceEndPoint.GET_MAXQUARTER_FOR_FREEZE_DT}?addQtr=1`)
    .then((response) => {
      return dispatch(setDefaultQtr(response.data));
    })
    .catch((response) => {
      dispatch(setDefaultQtr(response.date));
    });
};
